var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"m-t-20 m-b-20"},[_c('div',{staticClass:"divider"},[_c('img',{staticClass:"pt-3 w-16",attrs:{"src":"/images/marker.png","alt":"Marker"}})]),_vm._v(" "),_c('div',{staticClass:"legend"},[_c('span',[_vm._v("\n            Mais anúncios próximos ou similares baseados em sua pesquisa\n        ")])])])
}]

export { render, staticRenderFns }